// extracted by mini-css-extract-plugin
export default {"NavLink":"AuthNav_NavLink__C2bmY","NavBox":"AuthNav_NavBox__jEJ-f"};